import qs from 'qs';

// TODO(tech debt, found in #921): query values are written unencoded and read back with decodeURI, so a value
// containing `&` is split and `#` cuts the rest of the URL, and a raw `%` without hex digits makes decodeURI throw.
// Encoding values here would fix every page, but utils/searchParamsSaver.js and components/FiltersConfigurator.vue
// decode values themselves and must be re-checked first. #921 only encodes the campaign name on the
// Summary → Stats link (utils/statsCampaignName.ts).
export const parseQuery = (query) => {
  const isNumeric = (num) => {
    return !isNaN(num);
  };
  return qs.parse(query, {
    encode: false,
    ignoreQueryPrefix: true,
    decoder: (str) => {
      if (str === 'false') {
        return false;
      }
      if (str === 'true') {
        return true;
      }
      if (isNumeric(str)) {
        return +str;
      }
      return decodeURI(str);
    },
  });
};

export const stringifyQuery = (query) => {
  return Object.getOwnPropertyNames(query).length > 0 ? qs.stringify(query, { encode: false }) : '';
};
